import {Component, Input, ChangeDetectionStrategy} from '@angular/core';


@Component({
  selector: 'moti-popover-message',
  templateUrl: './popover-message.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './popover-message.component.scss',
})
export class PopoverMessageComponent {
  @Input() infoHtml: string = '';
  @Input() infoText: string = '';
  @Input() delay: number | [number, number];
}
